<div class="branding mat-bg-primary w-[210px] flex flex-row justify-start" [style.background-color]="getStyle()">
    <a routerLink="/dashboard">
        <img matTooltip="{{'Dashboard.Title' | translate }}"
             matTooltipPosition="right"
             [src]="THEME_PROFILE.staticFiles.logoBlackAndWhite"
             alt=""
             class="app-logo-text"
             style="margin-top: 0 !important;">
    </a>
</div>
